export const isIOS = () => {
    return (['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].some((agent) => navigator.userAgent.indexOf(agent) >= 0) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.indexOf('Mac') >= 0 && 'ontouchend' in document));
};
export const isApp = () => {
    return navigator.userAgent.indexOf('VRBT_APP') > -1;
};
export const openDialog = (message, callback) => {
    const container = document.getElementById('wrapper');
    if (!container) {
        return;
    }
    const outer = document.createElement('div');
    outer.setAttribute('class', 'pop-outer');
    outer.addEventListener('click', (e) => {
        if (e.target.id === 'confirm-button') {
            callback();
        }
    });
    outer.innerHTML = `<div class="cmm-dimmed-layer"></div><div class="pop-inner"><div class="base-txt-wrap"><div class="base-txt-box"><p class="g-txt" style="white-space: pre-wrap;">${message}</p></div></div><div class="pop-btn-module"><button type="button" class="acc" id="confirm-button">확인</button></div></div>`;
    container.appendChild(outer);
};
export const closeDialog = () => {
    const container = document.getElementById('wrapper');
    if (!container) {
        return;
    }
    const dialog = container.getElementsByClassName('pop-outer');
    container.removeChild(dialog[0]);
};
